import { useState } from "react";
import { handleData } from "../../api";
import { formatDateForForm } from "../../helperfunctions/helperfunctions";

const AdminNewOrEditActiviteit = (props) => {

    const { closeActiviteitForm, mode, closeEditActiviteit, activiteit={} } = props;
    const {_id="", naam ="", datum ="", omschrijving="" } = activiteit;
    const formDatum = formatDateForForm(datum);
    
    const [formData, setFormData] = useState({
        naam: naam,
        datum: formDatum,
        omschrijving: omschrijving
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (mode === "new") {
            const path = `activiteiten/new`
            const data = {
                method: 'POST',
                path: path,
                input: formData
            }
            const newActiviteit = await handleData(data);

        } else if(mode === "edit") {
            const path = `activiteiten/edit/${_id}`;
            const data = {
                method: 'PATCH',
                path: path,
                input: formData
            }
            const editActiviteit = await handleData(data);
        }
        
        setFormData({
            naam: "",
            datum: "",
            omschrijving: ""
        });
        if (mode === "new") {
            closeActiviteitForm(true);
        } else if (mode === "edit") {
            closeEditActiviteit();
            closeActiviteitForm(true);
        }
    }

    const handleFormUpdate = (e) => {
        setFormData({
            ...formData,
            [e.target.name] : e.target.value
        });
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setFormData({
            naam: "",
            datum: "",
            omschrijving: ""
        });
        if (mode === "new") {
            closeActiviteitForm(false);
        } else if (mode === "edit") {
            closeEditActiviteit();
        }
    }
    
    return (
        <>
            <div>
                <h3>{mode === "new" ? "Nieuwe activiteit" : "Wijzig activiteit"}</h3>
                <form onSubmit={handleSubmit}>
                    <div>
                        <p>Activiteit naam</p>
                        <input 
                            type="text" 
                            name= "naam"
                            value= {formData.naam}
                            onChange={handleFormUpdate}
                            required
                        />
                    </div>
                    <div>
                        <p>Activiteit datum</p>
                        <input 
                            type="date" 
                            name="datum"
                            value= {formData.datum}
                            onChange={handleFormUpdate}
                            required
                        />
                        
                    </div>
                    <div>
                        <p>Activiteit omschrijving</p>
                        <textarea 
                            cols="40"
                            rows="5" 
                            name="omschrijving"
                            value= {formData.omschrijving}
                            onChange={handleFormUpdate}
                        >
                        </textarea>

                    </div>
                    <div>
                        <button>Toevoegen</button>
                        <button onClick={handleCancel}>Annuleren</button>
                    </div>
                </form>
            </div>

        </>
    );
}

export default AdminNewOrEditActiviteit;
